import Component from 'can/component/component';

import template from './content-navigation.stache';

Component.extend({
    tag: 'drawer-content-navigation',
    template,
    viewModel: {
        init() {
            this.attr('isSubNavOpen', this.defaultSubNavOpen);
        },
        define: {
            currentTypeTitle: {
                type: 'string',
                value: null,
            },
            currentSubType: {
                type: 'string',
                value: null,
            },
            types: {
                type: 'array',
                value: [],
            },
            isNavOpen: {
                type: 'boolean',
                value: false,
            },
            defaultSubNavOpen: {
                type: 'boolean',
            },
            isSubNavOpen: {
                type: 'boolean',
            },
            currentType: {
                set(value) {
                    if (!this.types.length) {
                        return;
                    }

                    const type = this.types
                        .serialize()
                        .find((item) => item.type === value);
                    this.attr('currentTypeTitle', type && type.title);

                    return value;
                },
            },
        },
        selectType(type, subType) {
            if (type === 'stats' && !subType) {
                return this.toggleSubNavOpen();
            }

            this.toggleNavOpen();
            this.dispatch('selectType', [type, subType]);
        },
        toggleNavOpen() {
            this.attr('isNavOpen', !this.attr('isNavOpen'));
        },
        toggleSubNavOpen() {
            this.attr('isSubNavOpen', !this.attr('isSubNavOpen'));
        },
    },
});
